exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-label.custom_status {\r\n    margin-top: 0px;\r\n  }\r\n\r\n::ng-deep table.dataTable td.dataTables_empty {\r\n  display: none;\r\n}\r\n\r\n.text-primary, .text-muted {\r\n  cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/casherpay-users/casherpay-users.component.css
// module id = ../../../../../src/app/casherpay-users/casherpay-users.component.css
// module chunks = main